import { takeLatest, call, put } from 'redux-saga/effects'
import mandatoryCoursesList from 'api/home/MandatoryCourses'
import * as fromActions from '../../actions/courses.action'

async function getMandatoryList() {
  return await mandatoryCoursesList()
}

function* mandatoryCoursesListEffectSaga() {
  try {
    const data = yield call(getMandatoryList)
    yield put(fromActions.Actions.coursesUserMandatoryListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* mandatoryCoursesListWatcherSaga() {
  yield takeLatest(fromActions.COURSES_USER_GET_MANDATORY_LIST, mandatoryCoursesListEffectSaga)
}
